module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ca-root"
  }, [_c('div', {
    staticClass: "nc-surface ca-head"
  }, [_c('button', {
    staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }, [_vm._v("← Back")]), _vm._v(" "), _c('div', {
    staticClass: "ca-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.campaign.opportunity_name || 'Campaign'))]), _vm._v(" "), _c('div', {
    staticClass: "ca-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.campaign.country_name || '—') + " · " + _vm._s(_vm.campaign.customer_name || 'No customer') + " ·\n        " + _vm._s(_vm.windowText) + "\n        "), (_vm.triggerText) ? _c('span', [_vm._v(" · " + _vm._s(_vm.triggerText))]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "nc-badge",
    class: _vm.statusBadgeClass
  }, [_vm._v(_vm._s(_vm.statusLabel))]), _vm._v(" "), _c('button', {
    staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
    on: {
      "click": function($event) {
        return _vm.$emit('refresh')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ca-export"
  }, [_c('button', {
    staticClass: "nc-btn nc-btn-primary nc-btn-sm",
    on: {
      "click": function($event) {
        _vm.exportOpen = !_vm.exportOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n      ")]), _vm._v(" "), (_vm.exportOpen) ? _c('div', {
    staticClass: "nc-surface ca-export-menu"
  }, [_c('button', {
    staticClass: "ca-export-item",
    on: {
      "click": _vm.downloadReport
    }
  }, [_c('strong', [_vm._v("Report (PDF)")]), _vm._v(" "), _c('span', [_vm._v("The nudge preview, headline numbers, per-button responses, funnel and\n            trend on printable pages. Choose \"Save as PDF\" in the print window.")])]), _vm._v(" "), _c('button', {
    staticClass: "ca-export-item",
    on: {
      "click": _vm.runExport
    }
  }, [_c('strong', [_vm._v("Response summary (CSV)")]), _vm._v(" "), _c('span', [_vm._v("One row per user: delivered, replied, reply time, what they replied into, and\n            every funnel stage they reached.")])]), _vm._v(" "), _c('button', {
    staticClass: "ca-export-item",
    on: {
      "click": _vm.openTranscripts
    }
  }, [_c('strong', [_vm._v("Reply transcripts")]), _vm._v(" "), _c('span', [_vm._v("Full conversation threads for a sample of nudged users, uploaded to Drive.\n            Pick how many and which users.")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ca-tiles"
  }, [_c('div', {
    staticClass: "nc-surface ca-tile"
  }, [_c('div', {
    staticClass: "ca-tile-label"
  }, [_vm._v("Nudges sent")]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.attempts.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-sub"
  }, [_vm._v(_vm._s(_vm.totals.unique_users.toLocaleString()) + " distinct users")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface ca-tile"
  }, [_c('div', {
    staticClass: "ca-tile-label"
  }, [_vm._v("Delivered")]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.delivered.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-sub"
  }, [_vm._v(_vm._s(_vm.deliveryRate) + "% delivery")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface ca-tile"
  }, [_c('div', {
    staticClass: "ca-tile-label"
  }, [_vm._v("Replies")]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.responded.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-sub"
  }, [_vm._v("\n        " + _vm._s(_vm.replyRate) + "% of " + _vm._s(_vm.totals.delivered.toLocaleString()) + " delivered\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface ca-tile"
  }, [_c('div', {
    staticClass: "ca-tile-label"
  }, [_vm._v("Failed")]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-value"
  }, [_vm._v(_vm._s(_vm.totals.failed.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-sub"
  }, [_vm._v(_vm._s(_vm.failureRate) + "% of attempts")])]), _vm._v(" "), _c('div', {
    staticClass: "nc-surface ca-tile"
  }, [_c('div', {
    staticClass: "ca-tile-label"
  }, [_vm._v("Variants")]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-value"
  }, [_vm._v(_vm._s(_vm.variants.length || '—'))]), _vm._v(" "), _c('div', {
    staticClass: "ca-tile-sub"
  }, [_vm._v(_vm._s(_vm.variants.length > 1 ? 'A/B test running' : 'Single version'))])])]), _vm._v(" "), (_vm.previewGroups.length && !_vm.variants.length) ? _c('section', {
    staticClass: "nc-surface ca-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.previewGroups), function(group) {
    return _c('div', {
      key: group.groupId,
      staticClass: "ca-preview-group"
    }, [(_vm.previewGroups.length > 1) ? _c('div', {
      staticClass: "ca-preview-group-name"
    }, [_vm._v("\n        " + _vm._s(group.groupName || ("Group " + (group.groupId)))), (group.splitPercent) ? _c('span', [_vm._v(" · " + _vm._s(group.splitPercent) + "% of traffic")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ca-preview-grid"
    }, _vm._l((group.languages), function(l) {
      return _c('nudge-bubble', {
        key: l.language,
        attrs: {
          "message": l
        }
      })
    }), 1)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.buttonGroups.length) ? _c('section', {
    staticClass: "nc-surface ca-panel"
  }, [_c('header', {
    staticClass: "ca-panel-head"
  }, [_c('h3', [_vm._v("Button responses")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.buttonCaption))])]), _vm._v(" "), _vm._l((_vm.buttonGroups), function(group) {
    return _c('div', {
      key: group.groupId,
      staticClass: "ca-btn-group"
    }, [(_vm.buttonGroups.length > 1) ? _c('div', {
      staticClass: "ca-preview-group-name"
    }, [_vm._v(_vm._s(group.groupName || ("Group " + (group.groupId))))]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "ca-btn-table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_vm._l((group.buttons), function(b) {
      return _c('tr', {
        key: b.position
      }, [_c('td', [_c('strong', [_vm._v(_vm._s(b.position) + ". " + _vm._s(b.label))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(b.destinationLabel) + "\n              "), (b.sharedDestination) ? _c('span', {
        staticClass: "ca-btn-warn"
      }, [_vm._v("same destination as an earlier button, counted there")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "ca-num"
      }, [_vm._v(_vm._s(b.clicks.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "ca-num"
      }, [_vm._v(_vm._s(b.users.toLocaleString()))]), _vm._v(" "), _c('td', {
        staticClass: "ca-num"
      }, [_vm._v(_vm._s(_vm.percentage(b.clicks, group.clicks)) + "%")]), _vm._v(" "), _c('td', {
        staticClass: "ca-num"
      }, [_vm._v(_vm._s(_vm.percentage(b.clicks, _vm.deliveredOfGroup(group.groupId))) + "%")])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "ca-btn-total"
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("All buttons")]), _vm._v(" "), _c('td', {
      staticClass: "ca-num"
    }, [_vm._v(_vm._s(group.clicks.toLocaleString()))]), _vm._v(" "), _c('td', {
      staticClass: "ca-num"
    }), _c('td', {
      staticClass: "ca-num"
    }), _vm._v(" "), _c('td', {
      staticClass: "ca-num"
    }, [_vm._v(_vm._s(_vm.percentage(group.clicks, _vm.deliveredOfGroup(group.groupId))) + "%")])])], 2)]), _vm._v(" "), _c('p', {
      staticClass: "ca-panel-note"
    }, [_vm._v("\n        " + _vm._s(group.otherReplies.toLocaleString()) + " other " + _vm._s(group.otherReplies === 1 ? 'reply' : 'replies') + ":\n        typed messages that didn't route to a button's destination, out of\n        " + _vm._s(group.totalReplies.toLocaleString()) + " total.\n      ")])])
  }), _vm._v(" "), _c('p', {
    staticClass: "ca-panel-note"
  }, [_vm._v("\n      A response is counted when a reply lands in the destination a button points to. A user\n      who types that button's number lands in the same place, so it counts the same.\n    ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ca-columns"
  }, [_c('section', {
    staticClass: "nc-surface ca-panel"
  }, [_c('header', {
    staticClass: "ca-panel-head"
  }, [_c('h3', [_vm._v("Milestone progression")]), _vm._v(" "), _c('p', [_vm._v("\n          Distinct users at each stage, as a share of everyone nudged"), (_vm.funnelConfigured) ? _c('span', [_vm._v(".\n          Funnel stages attributed within " + _vm._s(_vm.funnel.attributionDays) + " days of the first\n          nudge")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ca-funnel"
  }, _vm._l((_vm.funnelStages), function(stage) {
    return _c('div', {
      key: stage.label,
      staticClass: "ca-stage"
    }, [_c('span', {
      staticClass: "ca-stage-label"
    }, [_vm._v(_vm._s(stage.label))]), _vm._v(" "), _c('span', {
      staticClass: "ca-stage-track"
    }, [_c('span', {
      staticClass: "ca-stage-fill",
      class: {
        'is-journey': stage.kind === 'journey'
      },
      style: ({
        width: ((stage.percent) + "%")
      })
    })]), _vm._v(" "), _c('span', {
      staticClass: "ca-stage-value"
    }, [_vm._v(_vm._s(stage.value.toLocaleString()))]), _vm._v(" "), _c('span', {
      staticClass: "ca-stage-percent"
    }, [_vm._v(_vm._s(stage.percent) + "%")])])
  }), 0), _vm._v(" "), (_vm.funnelAllZero) ? _c('p', {
    staticClass: "ca-panel-note ca-panel-note-warn"
  }, [_vm._v("\n        Every funnel stage reads zero although " + _vm._s(_vm.funnel.deliveredUsers.toLocaleString()) + "\n        users were delivered to. That is usually a mapping problem rather than a real\n        result — check that Funnel Stage Mapping points at conversation stages these users\n        actually pass through.\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.funnelConfigured) ? _c('p', {
    staticClass: "ca-panel-note ca-panel-note-warn"
  }, [_vm._v("\n        This journey has no funnel stage mapping configured, so there are no milestone,\n        referral or redemption stages to show. Configure it in Journey Settings → Funnel\n        Stage Mapping and they appear here automatically.\n      ")]) : (_vm.funnel.unmappedStages.length) ? _c('p', {
    staticClass: "ca-panel-note ca-panel-note-warn"
  }, [_vm._v("\n        Not shown, because no conversation stage is mapped to them:\n        " + _vm._s(_vm.funnel.unmappedStages.join(', ')) + ".\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "ca-panel-note"
  }, [_vm._v("\n        Everything here counts distinct users, not messages — the tiles above carry message\n        volume. Funnel stages are floored so a later stage never exceeds an earlier one: the\n        mapping is cumulative, but the raw per-stage counts aren't.\n      ")])]), _vm._v(" "), _c('section', {
    staticClass: "nc-surface ca-panel"
  }, [_c('header', {
    staticClass: "ca-panel-head ca-panel-head-row"
  }, [_c('div', [_c('h3', [_vm._v("Reply rate trend")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.trendCaption))])]), _vm._v(" "), _c('div', {
    staticClass: "ca-range"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localFrom),
      expression: "localFrom"
    }],
    staticClass: "nc-input nc-input-sm",
    attrs: {
      "type": "date",
      "aria-label": "Trend from"
    },
    domProps: {
      "value": (_vm.localFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ca-range-to"
  }, [_vm._v("to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localTo),
      expression: "localTo"
    }],
    staticClass: "nc-input nc-input-sm",
    attrs: {
      "type": "date",
      "aria-label": "Trend to"
    },
    domProps: {
      "value": (_vm.localTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "nc-btn nc-btn-ghost nc-btn-sm",
    on: {
      "click": _vm.applyRange
    }
  }, [_vm._v("Apply")]), _vm._v(" "), (_vm.hasSeparateModifiedDate) ? _c('button', {
    staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
    attrs: {
      "title": "First 7 days after this campaign was last modified"
    },
    on: {
      "click": _vm.useModifiedRange
    }
  }, [_vm._v("Since last edit")]) : _vm._e(), _vm._v(" "), (_vm.rangeChanged) ? _c('button', {
    staticClass: "nc-btn nc-btn-sm nc-btn-quiet",
    on: {
      "click": _vm.resetRange
    }
  }, [_vm._v("Reset")]) : _vm._e()])]), _vm._v(" "), _c('trend-chart', {
    attrs: {
      "days": _vm.filledDays
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ca-modal-fade"
    }
  }, [(_vm.transcriptOpen) ? _c('div', {
    staticClass: "ca-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeTranscripts.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nc-surface ca-modal"
  }, [_c('h4', {
    staticClass: "ca-modal-title"
  }, [_vm._v("Export reply transcripts")]), _vm._v(" "), _c('p', {
    staticClass: "ca-modal-body"
  }, [_vm._v("\n          Full conversation threads are uploaded to a Google Drive folder, which can take a\n          few minutes. Users are sampled at random from the cohort you pick — reading the\n          most recent few would tell you about last week rather than about the campaign.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ca-modal-field"
  }, [_c('label', {
    attrs: {
      "for": "ca-cohort"
    }
  }, [_vm._v("Which users")]), _vm._v(" "), _c('nv-select', {
    staticClass: "nc-input",
    attrs: {
      "id": "ca-cohort"
    },
    model: {
      value: (_vm.transcriptCohort),
      callback: function($$v) {
        _vm.transcriptCohort = $$v
      },
      expression: "transcriptCohort"
    }
  }, [_c('option', {
    attrs: {
      "value": "replied"
    }
  }, [_vm._v("Replied users" + _vm._s(_vm.cohortCountLabel('replied')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_replied"
    }
  }, [_vm._v("Did not reply" + _vm._s(_vm.cohortCountLabel('not_replied')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "any"
    }
  }, [_vm._v("Any nudged user" + _vm._s(_vm.cohortCountLabel('any')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca-modal-field"
  }, [_c('label', {
    attrs: {
      "for": "ca-count"
    }
  }, [_vm._v("How many transcripts")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transcriptCount),
      expression: "transcriptCount"
    }],
    staticClass: "nc-input",
    attrs: {
      "id": "ca-count",
      "type": "number",
      "min": "1",
      "max": _vm.transcriptMax
    },
    domProps: {
      "value": (_vm.transcriptCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.transcriptCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ca-modal-hint"
  }, [_vm._v("Between 1 and " + _vm._s(_vm.transcriptMax) + "." + _vm._s(_vm.cohortCapHint))])]), _vm._v(" "), _c('div', {
    staticClass: "ca-modal-actions"
  }, [_c('button', {
    staticClass: "nc-btn nc-btn-ghost",
    on: {
      "click": _vm.closeTranscripts
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "nc-btn nc-btn-primary",
    attrs: {
      "disabled": !_vm.transcriptValid
    },
    on: {
      "click": _vm.submitTranscripts
    }
  }, [_vm._v("\n            Export transcripts\n          ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.variants.length) ? _c('section', {
    staticClass: "nc-surface ca-panel"
  }, [_c('header', {
    staticClass: "ca-panel-head"
  }, [_c('h3', [_vm._v(_vm._s(_vm.isAbTest ? 'A/B variant results' : 'Content group'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.variantCaption))])]), _vm._v(" "), _c('div', {
    staticClass: "ca-variants"
  }, _vm._l((_vm.rankedVariants), function(variant, i) {
    return _c('div', {
      key: variant.group_id,
      staticClass: "ca-variant",
      class: {
        'is-leading': variant.isLeading
      }
    }, [_c('div', {
      staticClass: "ca-variant-head"
    }, [_c('span', {
      staticClass: "ca-swatch",
      style: ({
        background: _vm.seriesColor(i)
      }),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ca-variant-name"
    }, [_vm._v(_vm._s(variant.group_name || ("Group " + (variant.group_id))))]), _vm._v(" "), (variant.isLeading) ? _c('span', {
      staticClass: "nc-badge nc-badge-success"
    }, [_vm._v("Leading")]) : _vm._e(), _vm._v(" "), (_vm.isAbTest) ? _c('span', {
      staticClass: "ca-variant-split"
    }, [_vm._v(_vm._s(variant.split_percent || 0) + "% of traffic")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-rows"
    }, [_c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Reply rate")]), _c('strong', [_vm._v(_vm._s(_vm.rateOf(variant)) + "%")])]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Users reached")]), _c('strong', [_vm._v(_vm._s(variant.delivered_users.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Messages delivered")]), _c('strong', [_vm._v(_vm._s(variant.delivered.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Nudges replied to")]), _c('strong', [_vm._v(_vm._s(variant.responded.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Failed")]), _c('strong', [_vm._v(_vm._s(variant.failed.toLocaleString()))])]), _vm._v(" "), _c('div', {
      staticClass: "ca-variant-row"
    }, [_c('span', [_vm._v("Template")]), _c('strong', [_vm._v(_vm._s(variant.msg_template_name || 'Generated'))])])]), _vm._v(" "), (_vm.variantLanguages(variant).length) ? _c('div', {
      staticClass: "ca-variant-message"
    }, [_c('div', {
      staticClass: "ca-variant-message-head"
    }, [_c('span', [_vm._v("Message")]), _vm._v(" "), (_vm.variantLanguages(variant).length > 1) ? _c('div', {
      staticClass: "ca-lang-switch",
      attrs: {
        "role": "tablist"
      }
    }, _vm._l((_vm.variantLanguages(variant)), function(l) {
      return _c('button', {
        key: l.language,
        staticClass: "ca-lang-chip",
        class: {
          'is-active': l.language === _vm.variantMessage(variant).language
        },
        attrs: {
          "role": "tab",
          "aria-selected": l.language === _vm.variantMessage(variant).language,
          "title": l.language
        },
        on: {
          "click": function($event) {
            return _vm.pickLanguage(variant.group_id, l.language)
          }
        }
      }, [_vm._v(_vm._s(l.alias || l.language))])
    }), 0) : _vm._e()]), _vm._v(" "), _c('nudge-bubble', {
      attrs: {
        "message": _vm.variantMessage(variant)
      }
    })], 1) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.isAbTest) ? _c('p', {
    staticClass: "ca-panel-note"
  }, [_vm._v("\n      \"Leading\" is the higher observed reply rate, not a significance result — no\n      confidence test is run on these numbers.\n      "), (_vm.variantsShareUsers) ? [_vm._v("\n        This campaign re-fires, so the split is applied per send and some accounts received\n        both variants — the per-variant Users reached figures add up to more than the\n        campaign's " + _vm._s(_vm.totals.unique_users.toLocaleString()) + ". The message counts and the\n        rates above still partition exactly.\n      ")] : _vm._e()], 2) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "ca-panel-head"
  }, [_c('h3', [_vm._v("Nudge preview")]), _vm._v(" "), _c('p', [_vm._v("What the user receives, in each language.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Button")]), _c('th', [_vm._v("Goes to")]), _vm._v(" "), _c('th', {
    staticClass: "ca-num"
  }, [_vm._v("Responses")]), _c('th', {
    staticClass: "ca-num"
  }, [_vm._v("Users")]), _vm._v(" "), _c('th', {
    staticClass: "ca-num"
  }, [_vm._v("Share")]), _c('th', {
    staticClass: "ca-num"
  }, [_vm._v("% of delivered")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-27b6ed8a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/analytics/CampaignAnalytics.vue
// module id = vamG
// module chunks = 1